import { createSelector } from 'reselect'
import { RootState } from '../types'

export const fiatsSelector = (state: RootState): string[] => state.fiat.data

export const fiatsByQuerySelector = (query: string): ((state: RootState) => string[]) =>
  createSelector(fiatsSelector, (fiats): string[] => {
    const q = (query || '').toLowerCase()
    return fiats.filter((c) => c.toLowerCase().includes(q))
  })
